export const suppressLdErrors = (error: Error | unknown): void => {
  // https://support.launchdarkly.com/hc/en-us/articles/12998125691419-Error-LaunchDarklyFlagFetchError-network-error
  const ignoredErrors = ['LaunchDarklyFlagFetchError'];

  if (error instanceof Error) {
    if (!ignoredErrors.includes(error.name)) {
      console.error('[LaunchDarkly Error]', error.message, error);
    }
  } else {
    console.error('[LaunchDarkly Unknown Error]', error);
  }
};
